export class OPCSettings {
    logoRbA: string;
    defaultImage: string;
    maxImageSize: number;
    minImageSize: number;
    validImageFormat: string;
    commonImgPath: string;
    partSearchErrMessage: string;
    constructor() {
        const settings = JSON.parse(localStorage.getItem('settings'));
        return settings ? settings.opcSettings : null;
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/models/opcsettings.model.ts